import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "And so it ends",
  "description": "",
  "published": "2009-01-01T00:00:00.000Z",
  "redirect_from": ["/blog/and-so-it-ends/swizec/25"],
  "categories": "life",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`For the first day of 2009 I've decided to have a proper holiday for once. Unlike the rest of this extraordinarily long holiday season lasting a full 14 days when I have been or, as it is, still will be busy with a bunch of projects that have insane deadlines during or right after the season, today I haven't done any work whatsoever.`}</p>
    <p>{`So all I did today was have an extremely long lay in with my girlfriend, in fact, we got up only two hours after having woken up and that felt insanely good. No idea why we don't do it more often because she's the utmost divine squeeze. Dear girlfriend, why don't we have lay ins more often, not like we have anything much to do early in the mornings on weekends?`}</p>
    <p>{`Last night was quite fun as well I might add while I'm digresing like that. Was a tad cold though and the crowd we were with, most of them I'd only just met the previous day or at best this week. Shocking, I know. Not usualy that kind of guy, but hey, need to be a proper student now and anon right?`}</p>
    <p>{`Anyhow, the rest of what I did today was play with my new chess set. To be honest I can't even remember how long it's been since I first wanted a proper chess set with figures large enough not to make you squint and a nice wooden board that goes tock when you set a piece down. Seriously, whomever invented plastic chess pieces coupled with cardboard boards should be guilliotined.`}</p>
    <p>{`But since all good things must come to an end I will now have to get back to work and try finishing something today that should've been finished yesterday but alas, wasn't. And oh joy, if I finish it tonight then I have a full three days to do the massive cursework assignment by next week, but at least that's much more fun seeming as how I've found a way to work on my personal project as cursework. Yay.`}</p>
    <p>{`Please take care to look at the two sexy photos accompanying this post. They are quite awesome.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      